import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useQuery } from 'react-query'
import { fetchDocumentById } from '@dc-shared-web/hooks/api/document/fetchDocumentById'
import type { DocumentSvcCrunches } from '@dc-shared-web/hooks/api/document/types'

export const useGetDocument = (documentId: string, enabled: boolean = true) => {
  const svcCrunchApiClient = useSvcCrunchesContext()

  return useQuery<DocumentSvcCrunches, Error>({
    queryKey: ['DocumentSvcCrunches', documentId],
    queryFn: () => fetchDocumentById(svcCrunchApiClient, documentId),
    enabled,
  })
}
